import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { unconfirmedItems } from '@/mocks/home';

export default function UnconfirmedFeed() {
  return (
    <section id="unconfirmed" className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            index="02"
            title="待证实消息"
            subtitle="右侧百分比是核验进度，不代表确认。每条线索至少等待一个独立信源交叉后才会上版。"
          />
        </Reveal>

        <div className="mt-8 flex flex-col gap-3">
          {unconfirmedItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <article className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-background-300 md:flex-row md:items-center md:gap-6">
                <span className="w-fit shrink-0 rounded-md bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                  {item.category}
                </span>

                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-3 font-label text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-user-voice-line" />
                      </span>
                      {item.source}
                    </span>
                    <span className="h-3 w-px bg-background-300" />
                    <span>{item.updated}</span>
                  </div>
                </div>

                <div className="w-full shrink-0 md:w-40">
                  <div className="flex items-center justify-between font-label text-xs text-foreground-600">
                    <span>可信度</span>
                    <span className="font-medium text-foreground-950">{item.confidence}%</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${item.confidence}%` }}
                    />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-6 flex items-start gap-2 font-body text-xs leading-relaxed text-foreground-500">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
              <i className="ri-information-line" />
            </span>
            以上均为待证实线索，请勿作为事实依据传播；如后续被证伪，条目会保留并标注「已排除」。
          </p>
        </Reveal>
      </div>
    </section>
  );
}